module.exports = __webpack_public_path__ + "static/img/ps_down.82bba8aa.png";